import { forwardRef } from 'react'
import ScopeSelectbox from './ScopeSelectbox'

interface TagMultipleSelectProps {
  value: string[]
  onChange: (selected: string[]) => void
  placeholder?: string
  className?: string
  [key: string]: any
}

const TagMultipleSelect = forwardRef(
  (props: TagMultipleSelectProps, ref: any) => {
    return (
      <ScopeSelectbox
        ref={ref}
        url="api/v1/tags"
        optionLabel="name"
        optionValue="_id"
        tooltip={undefined}
        tooltipOptions={{ disabled: true }}
        {...props}
      />
    )
  }
)

export default TagMultipleSelect
